export const checkedDesktopStyle = {
  borderColor: 'primary.350',
  borderRightColor: 'primary.350',
  borderWidth: '2px',
  marginLeft: '-1px',
  '&:first-of-type': {
    marginLeft: '-2px',
  },
  '&:last-of-type': {
    marginRight: '-2px',
  },
  '& + *': {
    borderLeftWidth: '0',
  },
};

export const checkoutMobileStyle = {
  borderColor: 'primary.350',
  borderRightColor: 'primary.350',
  borderWidth: '2px',
  borderBottom: '2px',
  borderBottomColor: 'primary.350',
  '&:last-of-type': {
    borderBottom: '2px',
    borderBottomColor: 'primary.350',
  },
};

export const desktopStyle = {
  '&:first-of-type': {
    borderLeftRadius: '4px',
  },
  '&:last-of-type': {
    borderRightRadius: '4px',
  },
  'label.chakra-radio': {
    marginRight: '12px',
  },
  '&:not(:last-of-type):not([data-checked])': {
    borderRightColor: 'transparent',
  },
};

export const mobileStyle = {
  borderBottom: '0.5px',
  '&:last-of-type': {
    borderBottom: '1px solid',
  },
  svg: {
    marginLeft: 'auto',
  },
  '.chakra-radio__label': {
    width: '100%',
  },
  '&[data-checked] + .payment-item, &[aria-checked=true] + .payment-item': {
    borderTop: '0px',
  },
};
